import React, { useEffect, useState } from "react";
import { Switch } from "@headlessui/react";
import classnames from "classnames";

interface Props {
    enabled: boolean;
    size?: "small" | "large";
    onChange: (t: boolean) => void;
    classNames?: string;
    labelClassNames?: string;
    containerClassNames?: string;
    value?: any;
    label?: string;
    dark?: boolean;
    disabled?: boolean;
    description?: string;
}
export default function ToggleSwitch(props: Props) {
    const classes = classnames("toggle", props.classNames, {
        small: props.size === "small",
        dark: props.dark
    });

    return (
        <Switch
            checked={props.enabled}
            onChange={props.onChange}
            value={props.value}
            className={classes}
            disabled={props.disabled}
        >
            <span className="sr-only">Use setting</span>
            <span aria-hidden="true" className="switch" />
        </Switch>
    );
}

export function ToggleSwitchWithLabel(props: Props) {
    return (
        <Switch.Group as="div" className={props.containerClassNames}>
            <div className="flex items-center">
                <ToggleSwitch {...props} />
                <div className="ml-2">
                    <Switch.Label
                        as="div"
                        className={classnames("text-xs text-primary", props.labelClassNames)}
                    >
                        {props.label}
                    </Switch.Label>
                    {props.description && (
                        <p className="mt-1 text-xs text-gray-500">{props.description}</p>
                    )}
                </div>
            </div>
        </Switch.Group>
    );
}
